<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003606.installation.traitementPh' | translate"
      [description]="
        'P0003606.installation.traitementPh.description' | translate
      "
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P0003606.installation.regulation' | translate"
      [titleListe]="'P0003606.installation.regulation.value' | translate"
      [value]="actionStack!.getValue('iphPConsigneRegulationPh')"
      [liste]="P0003606ConsigneRegulationPh"
      [information]="P0003606ESPInstallationPh"
      (onPress)="
        actionStack!.editValue(
          P00039DataRxTxIndex.InjectionPh_Parametrage,
          'iphPConsigneRegulationPh',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    @if (
      hasProduitP0003600() > 0 ||
      hasProduitP0003601() > 0 ||
      hasProduitP0004700() > 0 ||
      hasProduitP00046() > 0
    ) {
      <app-switch-configuration
        [nameCustom]="'P0003606.installation.filtration.value' | translate"
        [value]="
          actionStack!.getValue('iphIActivationFonctionAutoMaintien') !== 0
        "
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.InjectionPh_Installation,
            'iphIActivationFonctionAutoMaintien',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>
    }

    <app-label-description
      [description]="'P0003606.installation.regulation.description' | translate"
    ></app-label-description>

    <app-label-configuration
      [title]="'P0003606.installation.correcteur.title' | translate"
      [description]="'P0003606.installation.correcteur.description' | translate"
      [titleListe]="'P0003606.installation.correcteur' | translate"
      [value]="actionStack!.getValue('iphITypeCorrecteurPh')"
      [liste]="P0003606TypeCorrecteurPh"
      [information]="P0003606TypeCorrecteurPhModal"
      (onPress)="
        actionStack!.editValue(
          P00039DataRxTxIndex.InjectionPh_Installation,
          'iphITypeCorrecteurPh',
          $event,
          null
        )
      "
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
